import React from 'react'
import FormBureau from '../../../Components/FormBureau'

const AjouterBureau = () => {
  return <FormBureau />
}

export default AjouterBureau
